import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Route, Router, Switch } from 'wouter'
import staticLocationHook from 'wouter/static-location'

import checkoutTrackingMetaCreator from 'artkive/components/Checkout/checkoutTrackingMetaCreator'
import EmailListForm from 'artkive/components/EmailListForm'
import Footer from 'artkive/components/Footer'
import Navbar from 'artkive/components/Navbar'
import withApp from 'artkive/hoc/withApp'
import useQueryPreservingLocation from 'artkive/hooks/useQueryPreservingLocation'
import routes from 'artkive/utils/routes'

import GiftCardConfirmation from '../GiftCardConfirmation/GiftCardConfirmation'
import GiftCards from '../GiftCards/GiftCards'

import GiftCardCheckout from './GiftCardCheckout'

const isSSR = typeof window === 'undefined'

const rootBase = ''

const GiftCardCheckoutNestedRouting = (props) => {
  const { railsContext, params: railsParams } = props
  const useLocation = isSSR
    ? staticLocationHook(railsContext.pathname.replace(rootBase, ''))
    : useQueryPreservingLocation

  const productLinks = useMemo(
    () => ({
      landing: routes.giftCards,
      checkout: routes.giftCardCheckout(railsParams.uuid),
      confirmation: routes.giftCardConfirmation,
    }),
    [railsParams],
  )

  return (
    <Switch>
      <Route path={productLinks.landing}>
        <Navbar />
        <GiftCards {...props} productLinks={productLinks} />
        <EmailListForm />
        <Footer />
      </Route>
      <Route path='/giftcards/:uuid/checkout/:activeStep?'>
        {(params) => (
          <Router base={routes.giftCardCheckout(params.uuid)} hook={useLocation}>
            <GiftCardCheckout {...props} params={params} productLinks={productLinks} />
          </Router>
        )}
      </Route>
      <Route path='/giftcards/:uuid/confirmation'>
        {(params) => (
          <>
            <Navbar />
            <GiftCardConfirmation {...props} params={params} productLinks={productLinks} />
            <Footer />
          </>
        )}
      </Route>
    </Switch>
  )
}

GiftCardCheckoutNestedRouting.propTypes = {
  params: PropTypes.object.isRequired,
  enableRecaptcha: PropTypes.bool.isRequired,
  railsContext: PropTypes.object,
}

export default withApp(GiftCardCheckoutNestedRouting, { trackingMetaCreator: checkoutTrackingMetaCreator })
